import React, { useEffect, useRef, useState } from "react";
import HiddenGestionaleModal from "./HiddenGestionaleModal";
import usePrecontoPrinter from "@/lib/usePrecontoPrinter";

/**
 * Controller del Movimento Gestionale (non fiscale).
 * NON attacca più handler ai children: l'apertura avviene tramite il gesto
 * nascosto sulla scritta SCONTRINO in cassa (long-press 2,5s su touch,
 * doppio click su PC) che emette l'evento window 'velta-gestionale-open'.
 * Attivo solo se la stampante Preconto ha il flag Movimenti Gestionali.
 */
export default function GestionaleLongPress({ orderId, total, tendered = 0, saveOrder, onClosed, children, className = "" }) {
  const { gestionaleEnabled } = usePrecontoPrinter();
  const [showModal, setShowModal] = useState(false);
  const [pendingOrderId, setPendingOrderId] = useState(orderId);

  const openRef = useRef(null);
  openRef.current = async () => {
    let oid = orderId;
    if (!oid && saveOrder) {
      const saved = await saveOrder();
      if (!saved) return;
      oid = saved.id;
    }
    if (!oid) return;
    setPendingOrderId(oid);
    setShowModal(true);
  };

  useEffect(() => {
    if (!gestionaleEnabled) return undefined;
    const handler = () => openRef.current?.();
    window.addEventListener("velta-gestionale-open", handler);
    return () => window.removeEventListener("velta-gestionale-open", handler);
  }, [gestionaleEnabled]);

  return (
    <>
      <div className={className}>{children}</div>
      <HiddenGestionaleModal
        open={showModal}
        onClose={() => setShowModal(false)}
        orderId={pendingOrderId || orderId}
        total={total}
        tendered={tendered}
        onSuccess={(closed) => { onClosed?.(closed); setShowModal(false); }}
      />
    </>
  );
}
